import styles from "./style/donutText.module.css";
import stylesMutual from "./style/stylesMutual.module.css";

const DonutText = ({text, percentage}) => {
  return (
    <div className={stylesMutual.outer}>
      <div className={styles.pie}  style={{
        backgroundImage: `conic-gradient(transparent 0%, transparent ${(100-percentage)}%, rgba(41, 148, 41, 1) ${(100-(percentage-2)) === 2 ? 0 : (100-(percentage-2))}%, rgb(255 0 0 / 1) 100%)`
      }}></div>
      <div className={styles.resultsPie}> 
        {percentage}%
      </div>
      {text &&
        <div className={styles.additionalTextDonut}>{text}</div>
      }
    </div>
  );
};

export default DonutText;
